import home_page_v2 from './home_page_v2';
import personal_online_shopping_page from './personal_online_shopping_page';
import personal_online_shopping_page_v2 from './personal_online_shopping_page_v2';
import personal_offline_kiosk_page from './personal_offline_kiosk_page';
import personal_offline_kiosk_page_v2 from './personal_offline_kiosk_page_v2';
import personal_qr_page from './personal_qr_page';
import personal_qr_page_v2 from './personal_qr_page_v2';
import personal_jpworldpay_creditcard_page_v2 from './personal_jpworldpay_creditcard_page_v2';
import personal_trade_cashback_page from './personal_trade_cashback_page';
import personal_trade_cashback_page_v2 from './personal_trade_cashback_page_v2';
import personal_send_page from './personal_send_page';
import personal_send_page_v2 from './personal_send_page_v2';
import personal_receive_page from './personal_receive_page';
import personal_receive_page_v2 from './personal_receive_page_v2';
import personal_deposit_page from './personal_deposit_page';
import personal_deposit_page_v2 from './personal_deposit_page_v2';
import personal_commission_page from './personal_commission_page';
import personal_commission_page_v2 from './personal_commission_page_v2';
import personal_account_page from './personal_account_page';
import personal_account_page_v2 from './personal_account_page_v2';
import personal_wallet_page from './personal_wallet_page';
import personal_wallet_page_v2 from './personal_wallet_page_v2';
import personal_jpys_page from './personal_jpys_page';
import personal_jpys_page_v2 from './personal_jpys_page_v2';
import personal_sale_page from './personal_sale_page';
import personal_sale_page_v2 from './personal_sale_page_v2';
import personal_exchange_page from './personal_exchange_page';
import personal_exchange_page_v2 from './personal_exchange_page_v2';
import business_start_page from './business_start_page';
import business_start_page_v2 from './business_start_page_v2';
import business_receive_page from './business_receive_page';
import business_receive_page_v2 from './business_receive_page_v2';
import business_pay_page from './business_pay_page';
import business_pay_page_v2 from './business_pay_page_v2';
import business_risk_page from './business_risk_page';
import business_risk_page_v2 from './business_risk_page_v2';
import business_corps_page from './business_corps_page';
import business_corps_page_v2 from './business_corps_page_v2';
import business_platform_page from './business_platform_page';
import business_platform_page_v2 from './business_platform_page_v2';
import business_pay_method_page from './business_pay_method_page';
import business_pay_method_page_v2 from './business_pay_method_page_v2';
import business_global_page from './business_global_page';
import business_global_page_v2 from './business_global_page_v2';
import business_asset_management_page_v2 from './business_asset_management_page_v2';
import development_main_page_v2 from './development_main_page_v2';
import business_development_page_v2 from './business_development_page_v2';

import components from './components';

export default {
	components,
	home_page_v2,
	personal_online_shopping_page,
	personal_online_shopping_page_v2,
	personal_offline_kiosk_page,
	personal_offline_kiosk_page_v2,
	personal_qr_page,
	personal_qr_page_v2,
	personal_jpworldpay_creditcard_page_v2,
	personal_trade_cashback_page,
	personal_trade_cashback_page_v2,
	personal_send_page,
	personal_send_page_v2,
	personal_receive_page,
	personal_receive_page_v2,
	personal_deposit_page,
	personal_deposit_page_v2,
	personal_commission_page,
	personal_commission_page_v2,
	personal_account_page,
	personal_account_page_v2,
	personal_wallet_page,
	personal_wallet_page_v2,
	personal_jpys_page,
	personal_jpys_page_v2,
	personal_sale_page,
	personal_sale_page_v2,
	personal_exchange_page,
	personal_exchange_page_v2,
	business_start_page,
	business_start_page_v2,
	business_receive_page,
	business_receive_page_v2,
	business_pay_page,
	business_pay_page_v2,
	business_risk_page,
	business_risk_page_v2,
	business_corps_page,
	business_corps_page_v2,
	business_platform_page,
	business_platform_page_v2,
	business_pay_method_page,
	business_pay_method_page_v2,
	business_global_page,
	business_global_page_v2,
	business_asset_management_page_v2,
	development_main_page_v2,
	business_development_page_v2,
};
